import { useHeaderContext } from "../../context/headerContext";
import { useEffect } from "react";
import IncidentIcon from "/public/images/icons/incidentsIcon.svg?react";

export default function ErrorScan() {
    const { setTitle, setBackButton } = useHeaderContext();

    useEffect(() => {
        setTitle("SCANNED BAND");
        setBackButton(true);
    }, []);

    return (
        <div className="flex flex-col gap-6 items-center h-full justify-center">
            <IncidentIcon className="[&>path]:fill-sportsRed w-[42px] h-[48px]" />
            <h3>Access Denied</h3>
            <p className="text-center text-sportsGrey">This band is not currently activated, reported lost or has been permanently disabled.</p>
        </div>
    )
}